const priceFormat = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
});

export function formatCurrency(price: number) {
  return priceFormat.format(price);
}
